import React from 'react';
import useEditorStore from '../../stores/useEditorStore';
import { mergeCells, unmergeCells, getCellMergeInfo } from '../../utils/tableMergeUtils';

/**
 * 테이블 셀 우클릭 컨텍스트 메뉴
 * @param {{ contextMenu, setContextMenu, canvas, pushHistory }} props
 */
const TableContextMenu = ({ contextMenu, setContextMenu, canvas, pushHistory }) => {
  if (!contextMenu) return null;

  const store = useEditorStore.getState();
  const canMerge = store.selectedTableCells.length >= 2;
  const mergeInfo = getCellMergeInfo(contextMenu.tableGroup, contextMenu.cellRow, contextMenu.cellCol);
  const canUnmerge = mergeInfo.isMerged;

  if (!canMerge && !canUnmerge) return null;

  const handleMerge = () => {
    const cells = store.selectedTableCells;
    const tableGroup = store.selectedTableGroup;
    if (tableGroup && cells.length >= 2) {
      mergeCells(tableGroup, cells, canvas);
      store.clearTableCellSelection();
      pushHistory();
    }
    setContextMenu(null);
  };

  const handleUnmerge = () => {
    const { tableGroup, cellRow, cellCol } = contextMenu;
    unmergeCells(tableGroup, cellRow, cellCol, canvas);
    useEditorStore.getState().clearTableCellSelection();
    pushHistory();
    setContextMenu(null);
  };

  return (
    <div
      style={{
        position: 'absolute', left: contextMenu.x, top: contextMenu.y, zIndex: 100,
        backgroundColor: '#fff', border: '1px solid #d1d5db', borderRadius: '8px',
        boxShadow: '0 10px 25px rgba(0,0,0,0.15)', padding: '4px 0', minWidth: '140px',
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {canMerge && (
        <button
          onClick={handleMerge}
          style={{
            display: 'block', width: '100%', padding: '8px 16px', fontSize: '13px',
            textAlign: 'left', border: 'none', backgroundColor: 'transparent',
            cursor: 'pointer', color: '#1f2937',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#eff6ff'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
        >
          셀 병합 ({store.selectedTableCells.length}개)
        </button>
      )}
      {canUnmerge && (
        <button
          onClick={handleUnmerge}
          style={{
            display: 'block', width: '100%', padding: '8px 16px', fontSize: '13px',
            textAlign: 'left', border: 'none', backgroundColor: 'transparent',
            cursor: 'pointer', color: '#dc2626',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#fef2f2'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
        >
          병합 해제
        </button>
      )}
    </div>
  );
};

export default TableContextMenu;
